import React, { useState } from "react";
import "./KycCard.css";
import { URL } from "../../Redux/common/url";

const KycCard = ({ kycData }) => {
    const [preview, setPreview] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = () => {
        setSubmitted(true);
        setTimeout(() => {
            setSubmitted(false);
        }, 5000);
    };

    return (
        <>
            <div className="kyc-wrapper">

                {/* SUCCESS ANIMATION */}
                {submitted && (
                    <div className="kyc-success">
                        <div className="particles">
                            {Array.from({ length: 30 }).map((_, i) => (
                                <span key={i} className="particle"></span>
                            ))}
                        </div>

                        <div className="success-box">
                            <div className="checkmark">✔</div>
                            <h2 className="text-white">KYC Submitted Successfully</h2>
                            <p className="text-white">
                                Please wait while we verify your documents
                            </p>
                        </div>
                    </div>
                )}

                <div className="kyc-card">

                    {/* HEADER */}
                    <div className="kyc-header">
                        <h2 className="fw-bold">KYC DETAILS</h2>
                    </div>

                    {/* BODY */}
                    <div className="kyc-body">

                        {/* BANK DETAILS */}
                        <div className="kyc-section">
                            <h3>🏦 Bank Information</h3>

                            <div className="kyc-row">
                                <span>Holder Name</span>
                                <strong>{kycData?.acc_holder || "—"}</strong>
                            </div>

                            <div className="kyc-row">
                                <span>Bank Name</span>
                                <strong>{kycData?.bank_name || "—"}</strong>
                            </div>

                            <div className="kyc-row">
                                <span>Branch Name</span>
                                <strong>{kycData?.branch_name || "—"}</strong>
                            </div>

                            <div className="kyc-row">
                                <span>Account Number</span>
                                <strong>{kycData?.acc_no || "—"}</strong>
                            </div>

                            <div className="kyc-row">
                                <span>IFSC Code</span>
                                <strong>{kycData?.ifsc || "—"}</strong>
                            </div>
                        </div>

                        {/* ID DETAILS */}
                        <div className="kyc-section">
                            <h3>🪪 Identity Details</h3>

                            <div className="kyc-row">
                                <span>Aadhaar Number</span>
                                <strong>{kycData?.aadhar_card || "—"}</strong>
                            </div>

                            <div className="kyc-row">
                                <span>Aadhaar Images</span>
                                <strong>
                                    {kycData?.aadharfrontImage ? "Uploaded" : "Not Uploaded"}
                                </strong>
                            </div>

                            <div className="kyc-images">
                                {kycData?.aadharfrontImage && (
                                    <img
                                        src={URL.API_BASE_URL + kycData.aadharfrontImage}
                                        alt="Aadhaar Front"
                                        onClick={() =>
                                            setPreview(URL.API_BASE_URL + kycData.aadharfrontImage)
                                        }
                                    />
                                )}

                                {kycData?.aadharbacktImage && (
                                    <img
                                        src={URL.API_BASE_URL + kycData.aadharbacktImage}
                                        alt="Aadhaar Back"
                                        onClick={() =>
                                            setPreview(URL.API_BASE_URL + kycData.aadharbacktImage)
                                        }
                                    />
                                )}
                            </div>

                            <div className="kyc-row">
                                <span>PAN Number</span>
                                <strong>{kycData?.pan_card || "—"}</strong>
                            </div>

                            <div className="kyc-row">
                                <span>PAN Card Image</span>
                                <strong>
                                    {kycData?.pancardImage ? "Uploaded" : "Not Uploaded"}
                                </strong>
                            </div>

                            <div className="kyc-images">
                                {kycData?.pancardImage && (
                                    <img
                                        src={URL.API_BASE_URL + kycData.pancardImage}
                                        alt="PAN Card"
                                        onClick={() =>
                                            setPreview(URL.API_BASE_URL + kycData.pancardImage)
                                        }
                                    />
                                )}
                            </div>
                        </div>

                        {/* SUBMIT BUTTON */}
                        {/* <button className="submit-btn" onClick={handleSubmit}>
                            Submit KYC
                        </button> */}
                    </div>

                    {/* <div className="kyc-footer">
                        {kycData ? "✔ KYC Submitted" : "⚠ KYC Not Available"}
                    </div> */}
                </div>
            </div>

            {/* IMAGE PREVIEW MODAL */}
            {preview && (
                <div className="img-modal" onClick={() => setPreview(null)}>
                    <img src={preview} alt="Preview" />
                </div>
            )}
        </>
    );
};

export default KycCard;
